import * as React from "react"
import {createRoot} from "react-dom/client"
import {ChakraProvider} from "@chakra-ui/react"
import thunk from "redux-thunk"
import {Provider} from "react-redux"
import {applyMiddleware, createStore} from "redux"

import "./prototypes"
import App from "./App"
import reducers from "./reducers"
import {theme} from "./styles/theme"
import "@libs/axiosHelper"
import "@libs/iconHelper"
import "./styles/tailwind.css"


const createStoreWithMiddleware = applyMiddleware(thunk)(createStore)
const store = createStoreWithMiddleware(reducers)

const container = document.getElementById("root")
const root = createRoot(container!)

root.render(
    <ChakraProvider theme={theme}>
        <Provider store={store}>
            <App/>
        </Provider>
    </ChakraProvider>
)
